module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/A_Few_Right_Thinking_Men2#Contents-A"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To all the right thinking men I have known,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("and the libertines who keep them in line.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5561f32b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/A_Few_Right_Thinking_Men-3.vue
// module id = 69
// module chunks = 0